import { h } from 'preact'
import { StateUpdater, useEffect, useState } from 'preact/hooks'
import { CalculatorDirection } from 'models/apps'
import SingleOption from './single-option'

interface CalculatorDirectionSelectProps {
  direction: CalculatorDirection
  handleSetDirection: StateUpdater<CalculatorDirection>
}

const FIXED_OPTION_LIST: CalculatorDirection[] = ['BUY', 'SELL']

const CalculatorDirectionSelect = ({ direction, handleSetDirection }: CalculatorDirectionSelectProps) => {
  const [isSelectVisible, setSelectVisibility] = useState<boolean>(false)

  const changeSelectVisibiliy = (): void => {
    setSelectVisibility(!isSelectVisible)
  }

  useEffect(() => {
    document
      .querySelector<HTMLDivElement>('.hero-form__main-section')
      .addEventListener('click', (e) => disableOptionsList(e))
  })

  const disableOptionsList = (e) => {
    const target = e?.target as HTMLElement
    const $summaryElement = document.querySelector<HTMLDivElement>('[data-direction-input]')
    if (e.target !== $summaryElement && isSelectVisible === true && !target.closest('[data-direction-holder]')) {
      setSelectVisibility(!isSelectVisible)
    }
  }

  const setSelectedOption = (option: CalculatorDirection): void => {
    handleSetDirection(option)
  }

  const handleSetClickedOption = (selectedOption: string): void => {
    const translatedOption = selectedOption === 'kupić' ? 'BUY' : 'SELL'
    setSelectedOption(translatedOption)
  }

  const translateOption = (direction: CalculatorDirection): string => {
    return direction === 'BUY' ? 'kupić' : 'sprzedać'
  }

  return (
    <div
      className="hero-form__options-holder"
      data-direction-holder
    >
      <div
        className="hero-form__select is-width"
        onClick={changeSelectVisibiliy}
        data-direction-input
      >
        <p>{translateOption(direction)}</p>
        <span className="hero-form__select-chevron" />
      </div>
      {isSelectVisible && (
        <div
          className="hero-form__options-list is-width"
          onClick={changeSelectVisibiliy}
        >
          {FIXED_OPTION_LIST.map((option) => (
            <SingleOption
              key={option}
              handleSetClickedOption={handleSetClickedOption}
              singleOption={translateOption(option)}
              selectedOption={translateOption(direction)}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default CalculatorDirectionSelect
